const toggle = document.querySelector(".nav-toggle");
const menu = document.querySelector(".mobile-nav");
const close = document.querySelector(".mobile-nav__close");
const mega = document.querySelector("[data-mega]");
const header = document.querySelector("[data-header]");

toggle.addEventListener("click", () => {
  header.classList.remove("is-hidden");
  menu.showModal();
  toggle.setAttribute("aria-expanded", "true");
});

close.addEventListener("click", () => menu.close());
menu.addEventListener("close", () => toggle.setAttribute("aria-expanded", "false"));
menu.addEventListener("click", (event) => {
  if (event.target === menu || event.target.closest("a")) menu.close();
});

document.addEventListener("click", (event) => {
  if (mega.open && !mega.contains(event.target)) mega.removeAttribute("open");
});

mega.addEventListener("click", (event) => {
  if (event.target.closest("a")) mega.removeAttribute("open");
});

mega.addEventListener("toggle", () => header.classList.remove("is-hidden"));

let lastScrollY = window.scrollY;
let scrollFrame;

function updateHeader() {
  const currentScrollY = Math.max(window.scrollY, 0);
  const delta = currentScrollY - lastScrollY;
  const menuOpen = menu.open || mega.open;

  if (!menuOpen && currentScrollY > 120 && delta > 6) header.classList.add("is-hidden");
  if (delta < -6 || currentScrollY <= 120 || menuOpen) header.classList.remove("is-hidden");

  updateOutcomeStory();
  updateGrowthWays();
  lastScrollY = currentScrollY;
  scrollFrame = undefined;
}

window.addEventListener("scroll", () => {
  if (!scrollFrame) scrollFrame = requestAnimationFrame(updateHeader);
}, { passive: true });

header.addEventListener("focusin", () => header.classList.remove("is-hidden"));
// =========================================================================
// POPUP FORM SUBMISSION (BREVO + D8A.CX + AUDIT REDIRECTION WITH EMAIL)
// =========================================================================
const v80Backdrop = document.querySelector(".v80-backdrop");

if (v80Backdrop) {
  const auditForm = v80Backdrop.querySelector(".v80-form-wrap");
  const websiteInput = auditForm?.querySelector('input[name="WEBSITE_URL"]');
  const emailInput = auditForm?.querySelector('input[name="EMAIL"]');
  const submitBtn = auditForm?.querySelector('button[type="submit"]');
  const statusMsg = auditForm?.querySelector(".v80-status-msg");

  let isSubmitting = false;

  // Real-time custom validity reset on typing
  websiteInput?.addEventListener("input", () => websiteInput.setCustomValidity(""));
  emailInput?.addEventListener("input", () => emailInput.setCustomValidity(""));

  auditForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (isSubmitting) return;

    // 1. Clean Domain Extraction (var80.com direct extract karega)
    let rawVal = websiteInput ? websiteInput.value.trim() : "";
    if (!rawVal) {
      if (websiteInput) {
        websiteInput.setCustomValidity("Please enter your website.");
        websiteInput.reportValidity();
      }
      return;
    }

    // Saare extra protocol, slashes aur www strip karo taaki pure domain bache
    let targetDomain = rawVal
      .toLowerCase()
      .replace(/^https?:\/\//i, "")
      .replace(/^www\./i, "")
      .replace(/\/.*$/, "")
      .trim();

    // 2. Strict Email Validation
    const emailVal = emailInput ? emailInput.value.trim().toLowerCase() : "";
    const strictEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z]{2,})+$/;

    if (!emailVal || !strictEmailRegex.test(emailVal)) {
      if (emailInput) {
        emailInput.setCustomValidity("Please enter a valid email address.");
        emailInput.reportValidity();
        emailInput.focus();
      }
      return;
    }

    // 3. Exact Audit URL with Query Params
    // const auditUrl = `https://audit.var80.com/?url=${targetDomain}&email=${encodeURIComponent(emailVal)}`;
    const auditUrl = `https://audit.var80.com/?url=${targetDomain}&email=${emailVal}`;

    // const newTab = window.open(auditUrl, "_blank");
    window.open(auditUrl, "_blank", "noopener,noreferrer");
    isSubmitting = true;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.style.opacity = "0.7";
    }

    if (statusMsg) {
      statusMsg.style.color = "#16a34a";
      statusMsg.textContent = "Opening your growth audit report...";
    }

    // 4. Brevo API Submission
    const formAction = auditForm.getAttribute("action") || auditForm.action;
    const brevoFormData = new FormData();
    brevoFormData.set("EMAIL", emailVal);
    brevoFormData.set("WEBSITE_URL", "https://" + targetDomain);

    try {
      await fetch(formAction, {
        method: "POST",
        body: brevoFormData,
        headers: { "Accept": "application/json" },
        mode: "cors"
      });
      console.log("Brevo audit details submitted successfully.");
    } catch (brevoErr) {
      console.warn("Brevo API Notice:", brevoErr);
    }

    // 5. D8a.cx Tracking POST
    const nowIso = new Date().toISOString();
    const randomAnonId = "c773f797-9613-4605-8818-" + Math.random().toString(36).substring(2, 14);
    const randomMsgId = "msg-" + Math.random().toString(36).substring(2, 15);

    const d8aPayload = {
      properties: {
        websiteUrl: "https://" + targetDomain,
        targetDomain: targetDomain,
        email: emailVal,
        formId: "v80-growth-audit-modal"
      },
      event: "growth_audit_requested",
      type: "track",
      channel: "web",
      context: {
        traits: {
          email: emailVal,
          websiteUrl: "https://" + targetDomain,
          action_name: "Growth Audit Requested"
        },
        sessionId: Date.now(),
        app: {
          name: "Holistic Growth Wellness",
          version: "1.0.0"
        },
        userAgent: navigator.userAgent,
        locale: navigator.language || "en-US",
        page: {
          path: window.location.pathname || "/holistic-growth-wellness",
          referrer: document.referrer,
          referring_domain: document.referrer ? new URL(document.referrer).hostname : "",
          title: document.title || "Holistic Growth Wellness",
          url: window.location.href
        }
      },
      originalTimestamp: nowIso,
      messageId: randomMsgId,
      userId: emailVal,
      anonymousId: randomAnonId,
      integrations: { All: true },
      sentAt: nowIso
    };

    try {
      await fetch("https://cdp.d8a.cx/v1/track", {
        method: "POST",
        headers: {
          "accept": "application/json",
          "authorization": "Basic ZnlvenhwZ2loaXVnemh2Z3Bmb3dpYmNkZWF4bnB2cmE6",
          "content-type": "application/json;charset=UTF-8",
          "sentat": nowIso,
          "anonymousid": randomAnonId
        },
        body: JSON.stringify(d8aPayload),
        mode: "cors"
      });
      console.log("D8a.cx Audit Tracked successfully:", d8aPayload.properties);
    } catch (d8aErr) {
      console.warn("D8a.cx tracking notice:", d8aErr);
    }

    // 6. Reset form & close modal
    setTimeout(() => {
      auditForm.reset();
      v80Backdrop.classList.remove("v80-show", "is-open", "active");
      if (statusMsg) statusMsg.textContent = "";
      isSubmitting = false;
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.style.opacity = "";
      }
    }, 2000);
  });
}

const signalStage = document.querySelector(".signal-stage");

if (signalStage) {
  const signalMap = signalStage.querySelector(".signal-map");
  const signalCore = signalStage.querySelector("[data-signal-core]");
  const signalNodes = [...signalStage.querySelectorAll("[data-signal-node]")];
  const corePorts = { profiles: .5, purchase: .42, campaign: .58, affinity: .34, lifecycle: .66 };

  function updateSignalPaths() {
    const stageRect = signalStage.getBoundingClientRect();
    const coreRect = signalCore.getBoundingClientRect();
    const mobile = matchMedia("(max-width: 40rem)").matches;
    const endY = coreRect.top - stageRect.top;

    signalMap.setAttribute("viewBox", `0 0 ${stageRect.width} ${stageRect.height}`);

    for (const node of signalNodes) {
      const name = node.dataset.signalNode;
      const rect = node.getBoundingClientRect();
      const leftSide = name === "purchase" || name === "affinity";
      const topNode = name === "profiles";
      const startX = topNode ? rect.left + rect.width / 2 - stageRect.left : (leftSide ? rect.right : rect.left) - stageRect.left;
      const startY = (topNode ? rect.bottom : rect.top + rect.height / 2) - stageRect.top;
      const endX = coreRect.left + coreRect.width * corePorts[name] - stageRect.left;
      const bendY = Math.min(startY + Math.max(32, stageRect.height * .04), endY - 20);
      const route = topNode
        ? `M${startX} ${startY}V${endY}`
        : mobile || name === "affinity" || name === "lifecycle"
          ? `M${startX} ${startY}H${endX}V${endY}`
          : `M${startX} ${startY}L${endX} ${bendY}V${endY}`;

      for (const path of signalStage.querySelectorAll(`[data-signal-path="${name}"]`)) path.setAttribute("d", route);
    }
  }

  new ResizeObserver(updateSignalPaths).observe(signalStage);
  document.fonts?.ready.then(updateSignalPaths);
  updateSignalPaths();
}

const outcomeStory = document.querySelector("[data-outcomes]");
const outcomeScenes = outcomeStory ? [...outcomeStory.querySelectorAll("[data-outcome-scene]")] : [];
const outcomeTitles = outcomeScenes.map((scene) => scene.querySelector("h3"));
const outcomePixels = outcomeStory?.querySelector(".outcome-pixels");
const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)");

const growthSystemCarousel = document.querySelector("[data-growth-system-carousel]");
if (growthSystemCarousel && !reducedMotion.matches) {
  const slides = [...growthSystemCarousel.querySelectorAll("[data-growth-system-slide]")];
  let activeSlide = 0;
  const observer = new IntersectionObserver(([entry]) => {
    if (!entry.isIntersecting) return;
    setInterval(() => {
      slides[activeSlide].classList.remove("is-active");
      slides[activeSlide].setAttribute("aria-hidden", "true");
      activeSlide = (activeSlide + 1) % slides.length;
      slides[activeSlide].classList.add("is-active");
      slides[activeSlide].setAttribute("aria-hidden", "false");
    }, 5000);
    observer.disconnect();
  }, { threshold: .2 });
  observer.observe(growthSystemCarousel);
}


function clamp(value) {
  return Math.min(1, Math.max(0, value));
}

function animateOutcomeScene(scene, progress) {
  for (const element of scene.querySelectorAll("[data-parallax]")) {
    const depth = Number(element.dataset.parallax);
    element.style.opacity = clamp(.35 + progress);
    element.style.transform = `translate3d(0, ${(1 - progress) * depth}px, 0)`;
  }

  scene.querySelectorAll("[data-reveal]").forEach((element, index) => {
    const reveal = clamp(progress * 1.5 - index * .08);
    element.style.opacity = reveal;
    element.style.transform = `translate3d(0, ${(1 - reveal) * 18}px, 0)`;
  });
}

function drawOutcomePixels(progress) {
  if (!outcomePixels) return;

  const density = progress < .03 ? 0
    : progress < .08 ? (progress - .03) / .05 * .5
      : progress < .12 ? .5 + (progress - .08) / .04 * .5
        : progress < .16 ? 1 - (progress - .12) / .04 * .75
          : progress < .19 ? .25 * (1 - (progress - .16) / .03) : 0;
  const ratio = devicePixelRatio || 1;
  const width = outcomePixels.clientWidth;
  const height = outcomePixels.clientHeight;
  const pixelWidth = Math.round(width * ratio);
  const pixelHeight = Math.round(height * ratio);
  if (outcomePixels.width !== pixelWidth || outcomePixels.height !== pixelHeight) {
    outcomePixels.width = pixelWidth;
    outcomePixels.height = pixelHeight;
  }
  const context = outcomePixels.getContext("2d");
  context.setTransform(ratio, 0, 0, ratio, 0, 0);
  context.clearRect(0, 0, width, height);
  if (!density) return;

  const styles = getComputedStyle(document.documentElement);
  const colors = ["--var80-signal-500", "--var80-ink-950", "--var80-rule-300"].map((token) => styles.getPropertyValue(token));
  const size = Math.max(7, Math.round(width / 72));
  const gap = size * 1.35;
  const columns = Math.floor(width / gap);
  const rows = Math.floor(height / gap);
  const offsetX = (width - (columns - 1) * gap) / 2;
  const offsetY = (height - (rows - 1) * gap) / 2;

  for (let row = 0; row < rows; row++) {
    for (let column = 0; column < columns; column++) {
      const seed = ((column * 37 + row * 73) % 101) / 100;
      const alpha = clamp((density - seed) * 8);
      if (!alpha) continue;
      context.globalAlpha = alpha * (.35 + (1 - Math.abs(column / columns - .5) * 2) * .5);
      context.fillStyle = colors[(column + row * 2) % colors.length];
      context.fillRect(offsetX + column * gap, offsetY + row * gap, size, size);
    }
  }
}

function updateOutcomeStory() {
  if (!outcomeStory || reducedMotion.matches) return;

  const rect = outcomeStory.getBoundingClientRect();
  const progress = clamp(-rect.top / Math.max(rect.height - innerHeight, 1));
  const starts = [.19, .35, .51, .67, .83];

  drawOutcomePixels(progress);
  outcomeScenes.forEach((scene, index) => {
    const enter = clamp((progress - starts[index]) / .05);
    const exit = index === outcomeScenes.length - 1 ? 0 : clamp((progress - starts[index + 1]) / .05);
    const opacity = enter * (1 - exit);
    scene.style.opacity = opacity;
    scene.style.transform = "none";
    scene.style.pointerEvents = opacity > .5 ? "auto" : "none";
    outcomeTitles[index].style.filter = `blur(${Math.max(1 - enter, exit) * 10}px)`;
    animateOutcomeScene(scene, clamp((progress - starts[index]) / .12));
  });
}

if (outcomeStory) {
  new ResizeObserver(updateOutcomeStory).observe(outcomeStory);
  updateOutcomeStory();
}

/**
 * Var80 Connected Growth Showcase - JS
 *
 * Behaviour:
 * 01 -> progress complete -> 02
 * 02 -> progress complete -> 03
 * 03 -> progress complete -> 04
 * 04 -> progress complete -> 01
 *
 * Desktop:
 * - Existing scroll based tab change
 *
 * Mobile:
 * - Same progress behaviour
 * - Active tab automatically slides into view
 * - Progress complete hote hi next tab slide hota hai
 */
(function () {
  const track = document.querySelector("[data-difference-track]");
  const tabs = [...document.querySelectorAll("[data-difference-tab]")];
  const stack = document.querySelector("[data-difference-stack]");
  const layers = [...(stack?.querySelectorAll("[data-stack-step]") ?? [])];
  const activeTabNum = document.querySelector("[data-active-tab-num]");
  const dots = [...document.querySelectorAll(".status-dot")];

  if (!track || tabs.length === 0) return;

  const totalTabs = tabs.length;

  let activeIndex = 0;
  let isClicking = false;
  let scrollRAF = null;

  /*
   * ---------------------------------------------------------
   * MOBILE TAB SLIDE
   * ---------------------------------------------------------
   */
  function slideToActiveTab(index) {
    const tabsContainer = document.querySelector(".difference-tabs");
    const currentTab = tabs[index];

    if (!tabsContainer || !currentTab) return;

    // Only slide tabs on mobile
    if (window.innerWidth > 767) return;

    const containerWidth = tabsContainer.clientWidth;
    const tabLeft = currentTab.offsetLeft;
    const tabWidth = currentTab.offsetWidth;

    const targetScrollLeft =
      tabLeft - (containerWidth / 2) + (tabWidth / 2);

    tabsContainer.scrollTo({
      left: Math.max(0, targetScrollLeft),
      behavior: "smooth"
    });
  }


  /*
   * ---------------------------------------------------------
   * SELECT TAB
   * ---------------------------------------------------------
   */
  function selectTab(index, shouldSlide = true) {
    if (index < 0) {
      index = 0;
    }

    if (index >= totalTabs) {
      index = totalTabs - 1;
    }

    activeIndex = index;

    tabs.forEach((tab, i) => {
      const selected = i === index;

      tab.setAttribute(
        "aria-selected",
        selected ? "true" : "false"
      );

      tab.tabIndex = selected ? 0 : -1;

      // Remove previous progress state
      tab.classList.remove("is-progressing");

      // Reset progress custom property
      tab.style.removeProperty("--tab-progress");
    });

    const currentTab = tabs[index];

    if (currentTab) {
      /*
       * Force browser to completely reset the
       * previous progress animation.
       */
      void currentTab.offsetWidth;

      /*
       * Start progress bar again.
       */
      currentTab.classList.add("is-progressing");
    }

    /*
     * Mobile:
     * Automatically move active tab into view.
     */
    if (shouldSlide) {
      slideToActiveTab(index);
    }

    /*
     * Update visual stack.
     */
    if (stack) {
      stack.dataset.active = index;
    }

    layers.forEach((layer, i) => {
      layer.classList.toggle(
        "is-active",
        i === index
      );
    });

    /*
     * Update dots.
     */
    dots.forEach((dot, i) => {
      dot.classList.toggle(
        "is-active",
        i === index
      );
    });

    /*
     * Update active number.
     */
    if (activeTabNum) {
      activeTabNum.textContent = String(index + 1);
    }
  }


  /*
   * ---------------------------------------------------------
   * PROGRESS BAR COMPLETE
   * ---------------------------------------------------------
   *
   * IMPORTANT:
   * We are NOT using a separate 4500ms timer anymore.
   *
   * The actual CSS progress bar decides when the next
   * tab should start.
   */
  tabs.forEach((tab, index) => {
    tab.addEventListener("animationend", function (event) {

      /*
       * Only react to our progress animation.
       */
      if (event.animationName !== "difference-progress") {
        return;
      }

      /*
       * Make sure this is still the active tab.
       */
      if (index !== activeIndex) {
        return;
      }

      /*
       * Move to next tab.
       *
       * 01 -> 02
       * 02 -> 03
       * 03 -> 04
       * 04 -> 01
       */
      const nextIndex =
        (activeIndex + 1) % totalTabs;

      selectTab(nextIndex, true);
    });
  });


  /*
   * ---------------------------------------------------------
   * SCROLL LISTENER
   * ---------------------------------------------------------
   *
   * Scroll changes the active tab exactly like desktop.
   */
  function handleScroll() {
    if (isClicking) return;

    const rect = track.getBoundingClientRect();

    const scrollDistance =
      rect.height - window.innerHeight;

    if (scrollDistance <= 0) return;

    if (
      rect.top <= 0 &&
      rect.bottom >= 0
    ) {
      const progress = Math.max(
        0,
        Math.min(
          1,
          -rect.top / scrollDistance
        )
      );

      const stepSize =
        1 / totalTabs;

      let targetIndex =
        Math.floor(progress / stepSize);

      if (targetIndex >= totalTabs) {
        targetIndex = totalTabs - 1;
      }

      /*
       * Only change tab when required.
       */
      if (targetIndex !== activeIndex) {
        selectTab(targetIndex, true);
      }
    }
  }


  /*
   * Use requestAnimationFrame so scroll does not
   * trigger excessive calculations.
   */
  window.addEventListener(
    "scroll",
    function () {

      if (scrollRAF) {
        cancelAnimationFrame(scrollRAF);
      }

      scrollRAF =
        requestAnimationFrame(handleScroll);

    },
    {
      passive: true
    }
  );


  /*
   * ---------------------------------------------------------
   * TAB CLICK
   * ---------------------------------------------------------
   */
  tabs.forEach((tab, i) => {

    tab.addEventListener("click", () => {

      /*
       * Change tab immediately.
       */
      selectTab(i, true);

      /*
       * Prevent scroll listener from fighting
       * with the smooth scroll.
       */
      isClicking = true;

      const rect =
        track.getBoundingClientRect();

      const currentScrollY =
        window.scrollY ||
        window.pageYOffset;

      const trackAbsoluteTop =
        currentScrollY + rect.top;

      const scrollDistance =
        track.offsetHeight -
        window.innerHeight;

      const targetY =
        trackAbsoluteTop +
        ((i + 0.5) / totalTabs) *
          scrollDistance;

      window.scrollTo({
        top: targetY,
        behavior: "smooth"
      });

      setTimeout(() => {
        isClicking = false;
      }, 800);
    });

  });


  /*
   * ---------------------------------------------------------
   * PAUSE PROGRESS ON HOVER
   * ---------------------------------------------------------
   *
   * Existing desktop behaviour preserved.
   */
  const tabsContainer =
    document.querySelector(".difference-tabs");

  if (tabsContainer) {

    tabsContainer.addEventListener(
      "mouseenter",
      () => {
        tabs.forEach((tab) => {
          tab.style.animationPlayState = "paused";
        });
      }
    );

    tabsContainer.addEventListener(
      "mouseleave",
      () => {
        tabs.forEach((tab) => {
          tab.style.animationPlayState = "";
        });
      }
    );
  }


  /*
   * ---------------------------------------------------------
   * RESIZE
   * ---------------------------------------------------------
   */
  window.addEventListener(
    "resize",
    () => {
      slideToActiveTab(activeIndex);
    }
  );


  /*
   * ---------------------------------------------------------
   * INITIAL TAB
   * ---------------------------------------------------------
   *
   * Start first tab.
   */
  selectTab(0, false);


  /*
   * Small delay ensures mobile container has
   * completed its initial layout before sliding.
   */
  setTimeout(() => {
    slideToActiveTab(activeIndex);
  }, 100);

})();

const growthWays = document.querySelector("[data-growth-ways]");
const growthWaysRail = growthWays?.querySelector(".growth-ways__rail");
const growthWayCards = [...(growthWaysRail?.children ?? [])];
const growthWaysMotion = matchMedia("(prefers-reduced-motion: reduce)");
let growthWayIndex = -1;

function updateGrowthWays() {
  if (!growthWays || growthWaysMotion.matches) return;
  const rect = growthWays.getBoundingClientRect();
  const progress = clamp(-rect.top / Math.max(rect.height - innerHeight, 1));
  const index = Math.round(progress * (growthWayCards.length - 1));
  if (index === growthWayIndex) return;
  growthWayIndex = index;
  growthWaysRail.scrollTo({ left: growthWayCards[index].offsetLeft - growthWayCards[0].offsetLeft, behavior: "smooth" });
}

if (growthWays) {
  new ResizeObserver(updateGrowthWays).observe(growthWays);
  updateGrowthWays();
}

const growthShaderPalettes = [
  ["--var80-signal-500", "--var80-warm-50", "--var80-signal-100"],
  ["--var80-signal-600", "--var80-signal-100", "--var80-paper-50"],
  ["--var80-signal-500", "--var80-rose-50", "--var80-signal-100"],
  ["--var80-signal-600", "--var80-mist-100", "--var80-warm-50"],
  ["--var80-signal-500", "--var80-mist-100", "--var80-rose-50"]
];

function createGrowthShader(canvas, scene) {
  const gl = canvas.getContext("webgl", { alpha: false, antialias: false });
  if (!gl) return;
  const compile = (type, source) => {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    return shader;
  };
  const program = gl.createProgram();
  gl.attachShader(program, compile(gl.VERTEX_SHADER, "attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}"));
  gl.attachShader(program, compile(gl.FRAGMENT_SHADER, `
    precision highp float;
    uniform vec2 r;
    uniform float t, s;
    uniform vec3 color1, color2, color3;
    float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
    void main() {
      vec2 uv=(2.*gl_FragCoord.xy-r)/min(r.x,r.y);
      float time=t*.000025+s*.42;
      mat2 rotate=mat2(.6428,-.766,.766,.6428);
      vec2 plane=rotate*(uv+vec2(.34,0.));
      float curve=plane.x+.16*sin(plane.y*.8+time);
      float band=exp(-curve*curve*.72);
      vec3 color=mix(color1,color2,smoothstep(-1.25,1.25,plane.x));
      color=mix(color,color3,band*.68);
      color*=.96+.08*band;
      float grain=hash(gl_FragCoord.xy+floor(t*.01))-0.5;
      color+=grain*.045;
      gl_FragColor=vec4(color,1.);
    }`));
  gl.linkProgram(program);
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return;
  gl.useProgram(program);
  gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
  const point = gl.getAttribLocation(program, "p");
  gl.enableVertexAttribArray(point);
  gl.vertexAttribPointer(point, 2, gl.FLOAT, false, 0, 0);
  const color = (token) => {
    const hex = getComputedStyle(document.documentElement).getPropertyValue(token).trim().slice(1);
    return [0, 2, 4].map((offset) => parseInt(hex.slice(offset, offset + 2), 16) / 255);
  };
  const sceneLocation = gl.getUniformLocation(program, "s");
  const colorLocations = ["color1", "color2", "color3"].map((name) => gl.getUniformLocation(program, name));
  const setScene = (nextScene) => {
    gl.useProgram(program);
    gl.uniform1f(sceneLocation, nextScene);
    growthShaderPalettes[nextScene].forEach((token, index) => gl.uniform3fv(colorLocations[index], color(token)));
  };
  setScene(scene);
  return { canvas, gl, resolution: gl.getUniformLocation(program, "r"), time: gl.getUniformLocation(program, "t"), setScene };
}

const growthShaders = [...document.querySelectorAll("[data-growth-shader]")].map((visual) => createGrowthShader(visual.querySelector("canvas"), Number(visual.dataset.growthShader))).filter(Boolean);

function renderGrowthShaders(time = 0) {
  for (const shader of growthShaders) {
    const ratio = Math.min(devicePixelRatio || 1, 1.5);
    const width = Math.round(shader.canvas.clientWidth * ratio);
    const height = Math.round(shader.canvas.clientHeight * ratio);
    if (shader.canvas.width !== width || shader.canvas.height !== height) {
      shader.canvas.width = width;
      shader.canvas.height = height;
    }
    shader.gl.viewport(0, 0, width, height);
    shader.gl.uniform2f(shader.resolution, width, height);
    shader.gl.uniform1f(shader.time, time);
    shader.gl.drawArrays(shader.gl.TRIANGLES, 0, 3);
  }
  if (!growthWaysMotion.matches) requestAnimationFrame(renderGrowthShaders);
}

if (growthShaders.length) renderGrowthShaders();

const diagnosisAction = document.querySelector("[data-diagnosis-action]");

if (diagnosisAction) {
  const tabs = [...diagnosisAction.querySelectorAll("[data-diagnosis-tab]")];
  const panels = [...diagnosisAction.querySelectorAll("[data-diagnosis-panel]")];
  const flow = diagnosisAction.querySelector("[data-diagnosis-flow]");
  const flowDiagnosis = flow.querySelector("[data-flow-diagnosis]");
  const flowAction = flow.querySelector("[data-flow-action]");
  const flowChannels = [...flow.querySelectorAll("[data-flow-channel]")];
  const flowMap = flow.querySelector(".diagnosis-flow__map");
  const flowSvg = flowMap.querySelector(":scope > svg");
  const routePaths = [...flow.querySelectorAll(".diagnosis-routes path")];
  const beamPaths = [...flow.querySelectorAll(".diagnosis-beams path")];
  const sourceNode = flow.querySelector('[data-flow-node="source"]');
  const gapNodes = [...flow.querySelectorAll('[data-flow-node="gap"]')];
  const paidAuditNode = flow.querySelector('[data-paid-flow-node="audit"]');
  const paidScanNode = flow.querySelector('[data-paid-flow-node="scan"]');
  const paidGroupNodes = [...flow.querySelectorAll('[data-paid-flow-node="group"]')];
  const paidDecisionNodes = [...flow.querySelectorAll('[data-paid-flow-node="decision"]')];
  const paidNodes = [paidAuditNode, paidScanNode, ...paidGroupNodes, ...paidDecisionNodes];
  const engineNode = flow.querySelector('[data-flow-node="engine"]');
  const actionNode = flow.querySelector('[data-flow-node="action"]');
  const channelNodes = [...flow.querySelectorAll(".diagnosis-node--channel")];
  const iconHolders = channelNodes.map((node) => node.querySelector("i"));
  const defaultIcons = iconHolders.map((holder) => holder.firstElementChild.cloneNode(true));
  const iconTemplates = new Map([...flow.querySelectorAll("[data-flow-icon-template]")].map((template) => [template.dataset.flowIconTemplate, template]));
  const flowDetails = channelNodes.map((node) => {
    const detail = document.createElement("small");
    detail.hidden = true;
    node.append(detail);
    return detail;
  });
  const panelShader = growthShaders.find((shader) => shader.canvas.closest(".diagnosis-panel__shader"));

  function drawDiagnosisFlow() {
    const mapRect = flowMap.getBoundingClientRect();
    const edge = (node, side) => {
      const rect = node.getBoundingClientRect();
      return { x: rect.left + rect.width / 2 - mapRect.left, y: rect[side] - mapRect.top };
    };
    const citationActive = flow.dataset.activeDiagnosis === "citation";
    const paidActive = flow.dataset.activeDiagnosis === "creative";
    const compactPaid = paidActive && matchMedia("(max-width: 40rem)").matches;
    const outputSource = actionNode.hidden ? engineNode : actionNode;
    const connections = paidActive
      ? compactPaid
        ? [[paidAuditNode, paidScanNode], [paidScanNode, engineNode], [engineNode, paidGroupNodes[0]], [paidGroupNodes[0], paidDecisionNodes[0]], [paidDecisionNodes[0], paidGroupNodes[1]], [paidGroupNodes[1], paidDecisionNodes[1]], [paidDecisionNodes[1], paidGroupNodes[2]], [paidGroupNodes[2], paidDecisionNodes[2]]]
        : [[paidAuditNode, paidScanNode], [paidScanNode, engineNode], ...paidGroupNodes.map((node) => [engineNode, node]), ...paidGroupNodes.map((node, index) => [node, paidDecisionNodes[index]])]
      : citationActive
        ? [...gapNodes.map((node) => [sourceNode, node]), ...gapNodes.map((node) => [node, engineNode]), [engineNode, actionNode], ...channelNodes.map((node) => [actionNode, node])]
        : [[sourceNode, engineNode], ...(actionNode.hidden ? [] : [[engineNode, actionNode]]), ...channelNodes.map((node) => [outputSource, node])];
    const primaryNodes = paidActive
      ? [paidAuditNode, paidScanNode, engineNode, paidGroupNodes[1], paidDecisionNodes[1]]
      : citationActive
        ? [sourceNode, gapNodes[1], engineNode, actionNode, channelNodes[1]]
        : [sourceNode, engineNode, ...(actionNode.hidden ? [] : [actionNode]), channelNodes[1]];
    const curve = (fromNode, toNode, continuing = false) => {
      const from = edge(fromNode, "bottom");
      const to = edge(toNode, "top");
      const bend = Math.max(20, (to.y - from.y) / 2);
      return (continuing ? "L" : "M") + from.x + " " + from.y + " C" + from.x + " " + (from.y + bend) + " " + to.x + " " + (to.y - bend) + " " + to.x + " " + to.y;
    };
    flowSvg.setAttribute("viewBox", '0 0 ' + mapRect.width + ' ' + mapRect.height);
    routePaths.forEach((route, index) => {
      const connection = connections[index];
      if (!connection) {
        route.removeAttribute("d");
        return;
      }
      route.setAttribute("d", curve(...connection));
    });
    beamPaths[0].setAttribute("d", primaryNodes.slice(1).map((node, index) => curve(primaryNodes[index], node, index > 0)).join(" "));
    beamPaths.slice(1).forEach((beam) => beam.removeAttribute("d"));
  }

  function selectDiagnosis(tab, focus = false) {
    const panel = diagnosisAction.querySelector("#" + tab.getAttribute("aria-controls"));
    tabs.forEach((item) => {
      const selected = item === tab;
      item.setAttribute("aria-selected", selected);
      item.tabIndex = selected ? 0 : -1;
    });
    panels.forEach((item) => item.hidden = item !== panel);
    panelShader?.setScene(tabs.indexOf(tab));
    flow.dataset.activeDiagnosis = tab.dataset.diagnosisTab;
    const paidActive = tab.dataset.diagnosisTab === "creative";
    gapNodes.forEach((node) => node.hidden = tab.dataset.diagnosisTab !== "citation");
    paidNodes.forEach((node) => node.hidden = !paidActive);
    sourceNode.hidden = paidActive;
    engineNode.hidden = false;
    actionNode.hidden = paidActive || panel.hasAttribute("data-flow-direct");
    channelNodes.forEach((node) => node.hidden = paidActive);
    flowDiagnosis.textContent = panel.dataset.flowDiagnosis;
    flowAction.textContent = panel.dataset.flowAction;
    panel.dataset.flowChannels.split("|").forEach((label, index) => flowChannels[index].textContent = label);
    const details = panel.dataset.flowDetails?.split("|") || [];
    const icons = panel.dataset.flowIcons?.split("|") || [];
    channelNodes.forEach((node, index) => {
      flowDetails[index].textContent = details[index] || "";
      flowDetails[index].hidden = !details[index];
      const icon = iconTemplates.get(icons[index])?.content.firstElementChild || defaultIcons[index];
      iconHolders[index].replaceChildren(icon.cloneNode(true));
    });
    flow.classList.remove("is-updating");
    void flow.offsetWidth;
    flow.classList.add("is-updating");
    requestAnimationFrame(drawDiagnosisFlow);
    if (focus) tab.focus();
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => selectDiagnosis(tab));
    tab.addEventListener("keydown", (event) => {
      const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
      if (!step && event.key !== "Home" && event.key !== "End") return;
      event.preventDefault();
      const next = event.key === "Home" ? 0 : event.key === "End" ? tabs.length - 1 : (index + step + tabs.length) % tabs.length;
      selectDiagnosis(tabs[next], true);
    });
  });

  new ResizeObserver(drawDiagnosisFlow).observe(flowMap);
  document.fonts?.ready.then(drawDiagnosisFlow);
  drawDiagnosisFlow();
}

const growthModel = document.querySelector("[data-growth-model]");

if (growthModel) {
  const growthTabs = [...growthModel.querySelectorAll("[data-growth-model-tab]")];
  const growthPanels = [...growthModel.querySelectorAll("[data-growth-model-panel]")];
  const growthToggle = growthModel.querySelector(".growth-model__toggle");
  const linearStage = growthModel.querySelector("[data-linear-stage]");
  const growthMotion = matchMedia("(prefers-reduced-motion: reduce)");
  let growthStarted = false;
  let growthAutoComplete = false;
  let growthVisible = false;
  let growthTransition = 0;
  let growthTimer;
  let linearTimers = [];
  const linearFrames = [
    [0, "$20K", "$0", "0", "0", "$100K", "0%"],
    [550, "$20K", "$12K", "24K", "320", "$100K", "12%"],
    [1350, "$20K", "$20K", "48K", "1,250", "$100K", "100%"],
    [2200, "$27K", "$27K", "60K", "1,600", "$130K", "21%"],
    [3100, "$32K", "$32K", "82K", "2,400", "$160K", "62%"]
  ];

  const playLinearModel = () => {
    linearTimers.forEach(clearTimeout);
    linearTimers = linearFrames.map(([delay, spend, metricSpend, clicks, orders, target, progress], step) => setTimeout(() => {
      linearStage.dataset.step = step;
      linearStage.querySelector("[data-linear-spend]").textContent = spend;
      linearStage.querySelector('[data-linear-metric="spend"]').textContent = metricSpend;
      linearStage.querySelector('[data-linear-metric="clicks"]').textContent = clicks;
      linearStage.querySelector('[data-linear-metric="orders"]').textContent = orders;
      linearStage.querySelector("[data-linear-target]").textContent = target;
      linearStage.querySelector("[data-linear-progress]").textContent = progress;
    }, delay));
  };

  const selectGrowthModel = (model, moveFocus = false) => {
    const transition = ++growthTransition;
    const activePanel = growthPanels.find((panel) => !panel.hidden);
    const nextPanel = growthPanels.find((panel) => panel.dataset.growthModelPanel === model);
    growthToggle.dataset.active = model;
    if (model === "linear" && !growthMotion.matches) playLinearModel();
    else linearTimers.forEach(clearTimeout);
    growthTabs.forEach((tab) => {
      const selected = tab.dataset.growthModelTab === model;
      tab.setAttribute("aria-selected", String(selected));
      tab.tabIndex = selected ? 0 : -1;
      if (selected && moveFocus) tab.focus();
    });

    if (activePanel === nextPanel) {
      activePanel.classList.remove("is-leaving");
      return;
    }
    const reveal = () => {
      if (transition !== growthTransition) return;
      activePanel.hidden = true;
      activePanel.classList.remove("is-leaving");
      nextPanel.hidden = false;
      nextPanel.classList.remove("is-entering");
      requestAnimationFrame(() => nextPanel.classList.add("is-entering"));
    };
    if (growthMotion.matches) {
      activePanel.hidden = true;
      nextPanel.hidden = false;
      return;
    }
    activePanel.classList.remove("is-entering");
    activePanel.classList.add("is-leaving");
    activePanel.addEventListener("animationend", reveal, { once: true });
  };

  const scheduleGrowthReveal = () => {
    clearTimeout(growthTimer);
    if (growthVisible && !growthAutoComplete && !growthMotion.matches && !document.hidden) {
      growthTimer = setTimeout(() => {
        growthAutoComplete = true;
        selectGrowthModel("compounding");
      }, 4200);
    }
  };

  new IntersectionObserver(([entry]) => {
    growthVisible = entry.isIntersecting;
    if (growthVisible && !growthStarted) {
      growthStarted = true;
      selectGrowthModel("linear");
    } else if (growthVisible && !growthAutoComplete && growthToggle.dataset.active === "linear") playLinearModel();
    else if (!growthVisible) linearTimers.forEach(clearTimeout);
    scheduleGrowthReveal();
  }, { threshold: .35 }).observe(growthModel);

  growthTabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      growthAutoComplete = true;
      clearTimeout(growthTimer);
      selectGrowthModel(tab.dataset.growthModelTab);
    });
    tab.addEventListener("keydown", (event) => {
      let next = index;
      if (["ArrowRight", "ArrowDown"].includes(event.key)) next = (index + 1) % growthTabs.length;
      else if (["ArrowLeft", "ArrowUp"].includes(event.key)) next = (index - 1 + growthTabs.length) % growthTabs.length;
      else if (event.key === "Home") next = 0;
      else if (event.key === "End") next = growthTabs.length - 1;
      else return;
      event.preventDefault();
      growthAutoComplete = true;
      clearTimeout(growthTimer);
      selectGrowthModel(growthTabs[next].dataset.growthModelTab, true);
    });
  });

  document.addEventListener("visibilitychange", scheduleGrowthReveal);
}

const choiceSection = document.querySelector("[data-choice-section]");

if (choiceSection) {
  const choiceList = choiceSection.querySelector(".choice-list");
  const choiceItems = [...choiceList.querySelectorAll("details")];
  const choiceMotion = matchMedia("(prefers-reduced-motion: reduce)");
  let choiceStarted = false;

  new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting && !choiceStarted) {
      choiceItems.forEach((item, index) => item.open = index === 0);
      choiceStarted = true;
    }
    choiceSection.classList.toggle("is-visible", entry.isIntersecting);
  }, { threshold: .2 }).observe(choiceSection);

  choiceList.addEventListener("animationend", (event) => {
    if (choiceMotion.matches || event.animationName !== "choice-progress" || !event.target.matches("details > div")) return;
    const current = event.target.closest("details");
    if (!current.open) return;
    const next = choiceItems[(choiceItems.indexOf(current) + 1) % choiceItems.length];
    choiceItems.forEach((item) => item.open = item === next);
  });
}

const personaSection = document.querySelector("[data-persona-section]");

if (personaSection) {
  const tabs = [...personaSection.querySelectorAll("[data-persona-tab]")];
  const panel = personaSection.querySelector("[data-persona-panel]");
  const profiles = {
    chief: {
      promise: "Make every team accountable to one growth plan.",
      title: "See one revenue plan", copy: "Connect brand, acquisition, conversion, and retention contribution in one operating view.",
      signals: ["Growth priorities", "Budget confidence", "Revenue contribution"], metric: "+18%", metricLabel: "repeat revenue opportunity"
    },
    growth: {
      promise: "Turn customer signals into the next best experiment.",
      title: "Move the next lever faster", copy: "See the journeys, pages, and audiences most likely to improve revenue now.",
      signals: ["CRO experiments", "Paid efficiency", "Journey gaps"], metric: "3.2x", metricLabel: "faster prioritisation"
    },
    brand: {
      promise: "Know which stories attract customers who are ready to buy.",
      title: "See what creates demand", copy: "Connect concepts, claims, and creative patterns to qualified traffic and conversion.",
      signals: ["Winning claims", "Content demand", "Creative fatigue"], metric: "24%", metricLabel: "more qualified visits"
    },
    retention: {
      promise: "Reach each customer before their next revenue moment passes.",
      title: "Act before customers lapse", copy: "Use purchase rhythm and behavior to trigger the next best retention move.",
      signals: ["Refill windows", "Dormant VIPs", "Subscriptions"], metric: "+18%", metricLabel: "repeat purchase lift"
    }
  };
  const fields = {
    promise: "[data-persona-promise]", title: "[data-persona-title]", copy: "[data-persona-copy]",
    metric: "[data-persona-metric]", metricLabel: "[data-persona-metric-label]"
  };
  const images = [...panel.querySelectorAll("[data-persona-image]")];

  function selectPersona(tab, focus = false) {
    const key = tab.dataset.personaTab;
    const profile = profiles[key];
    tabs.forEach((item) => {
      const selected = item === tab;
      item.setAttribute("aria-selected", selected);
      item.tabIndex = selected ? 0 : -1;
    });
    panel.dataset.active = key;
    panel.setAttribute("aria-labelledby", tab.id);
    Object.entries(fields).forEach(([name, selector]) => panel.querySelector(selector).textContent = profile[name]);
    panel.querySelectorAll("[data-persona-signal]").forEach((item, index) => item.textContent = profile.signals[index]);
    images.forEach((image) => image.hidden = image.dataset.personaImage !== key);
    panel.classList.remove("is-animating");
    void panel.offsetWidth;
    panel.classList.add("is-animating");
    if (focus) tab.focus();
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => selectPersona(tab));
    tab.addEventListener("keydown", (event) => {
      const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
      if (!step && event.key !== "Home" && event.key !== "End") return;
      event.preventDefault();
      const next = event.key === "Home" ? 0 : event.key === "End" ? tabs.length - 1 : (index + step + tabs.length) % tabs.length;
      selectPersona(tabs[next], true);
    });
  });
  selectPersona(tabs[0]);
}

const closingCta = document.querySelector("[data-closing-cta-section]");

if (closingCta && !reducedMotion.matches) {
  closingCta.classList.add("is-ready");
  const observer = new IntersectionObserver(([entry]) => {
    if (!entry.isIntersecting) return;
    closingCta.classList.add("is-visible");
    observer.disconnect();
  }, { threshold: .2 });
  observer.observe(closingCta);
}

const guaranteeDialog = document.querySelector("[data-guarantee-dialog]");

if (guaranteeDialog) {
  let opener;
  const form = guaranteeDialog.querySelector("[data-guarantee-form]");
  const status = guaranteeDialog.querySelector("[data-guarantee-status]");
  const submitBtn = form?.querySelector('button[type="submit"]');

  // Open Dialog Buttons
  for (const trigger of document.querySelectorAll("[data-guarantee-open]")) {
    trigger.addEventListener("click", () => {
      opener = trigger;
      guaranteeDialog.showModal();
    });
  }

  // Close Dialog Handling
  guaranteeDialog.querySelector("[data-guarantee-close]").addEventListener("click", () => guaranteeDialog.close());
  guaranteeDialog.addEventListener("click", (event) => {
    if (event.target === guaranteeDialog) guaranteeDialog.close();
  });
  guaranteeDialog.addEventListener("close", () => opener?.focus());
// =========================================================================
// REAL-TIME INPUT RESTRICTIONS
// =========================================================================
const customPhoneInput = form.querySelector("#guarantee-phone-custom");
const emailInput = form.querySelector("#guarantee-email");
const websiteInput = form.querySelector("#guarantee-website");
const messageInput = form.querySelector("#guarantee-message");

// Phone: Real-time non-digits filter
if (customPhoneInput) {
  customPhoneInput.addEventListener("input", (e) => {
    e.target.value = e.target.value.replace(/[^0-9\s\-()]/g, "");
    e.target.setCustomValidity("");
  });
}

// Email: Clear custom error on typing
if (emailInput) {
  emailInput.addEventListener("input", (e) => {
    e.target.setCustomValidity("");
  });
}

// Website: Clear custom error on typing
if (websiteInput) {
  websiteInput.addEventListener("input", (e) => {
    e.target.setCustomValidity("");
  });
}

// =========================================================================
// SUBMISSION FLOW: 1. Brevo Form POST  ->  2. D8a.cx Track POST
// =========================================================================
let isSubmitting = false;

form.addEventListener("submit", async (event) => {
  event.preventDefault();

  if (isSubmitting) return;

  // -------------------------------------------------------------
  // 1. INLINE STRICT EMAIL VALIDATION (No "not defined" issue)
  // -------------------------------------------------------------
  const emailVal = emailInput ? emailInput.value.trim().toLowerCase() : "";
  const strictEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z]{2,})+$/;

  let emailErrorMsg = "";

  if (!emailVal || !strictEmailRegex.test(emailVal)) {
    emailErrorMsg = "Please enter a valid, complete email address (e.g. name@company.com).";
  } else {
    const parts = emailVal.split("@");
    const domain = parts[1] || "";

    // Common typo checks (gmail.co, yahoo.co, gamil, etc.)
    const typoMap = {
      "gmail.co": "gmail.com",
      "gmai.com": "gmail.com",
      "gamil.com": "gmail.com",
      "gmail.cm": "gmail.com",
      "hotmail.co": "hotmail.com",
      "outlook.co": "outlook.com",
      "yahoo.co": "yahoo.com"
    };

    if (typoMap[domain]) {
      emailErrorMsg = `Incomplete domain. Did you mean @${typoMap[domain]}?`;
    }
  }

  if (emailErrorMsg) {
    if (emailInput) {
      emailInput.setCustomValidity(emailErrorMsg);
      emailInput.reportValidity();
    }
    return;
  } else if (emailInput) {
    emailInput.setCustomValidity("");
  }

  // -------------------------------------------------------------
  // 2. PHONE VALIDATION (10 Digits North America - No Country Code)
  // -------------------------------------------------------------
  const phoneValue = customPhoneInput ? customPhoneInput.value.trim() : "";
  let digitsOnly = phoneValue.replace(/\D/g, "");

  // Agar user galti se 11-digit daale (+1 ke sath), to leading 1 strip karo
  if (digitsOnly.length === 11 && digitsOnly.startsWith("1")) {
    digitsOnly = digitsOnly.substring(1);
  }

  if (digitsOnly.length !== 10) {
    if (customPhoneInput) {
      customPhoneInput.setCustomValidity("Please enter a valid 10-digit phone number.");
      customPhoneInput.reportValidity();
    }
    return;
  } else if (customPhoneInput) {
    customPhoneInput.setCustomValidity("");
  }

  // -------------------------------------------------------------
  // 3. WEBSITE URL VALIDATION (http/https check & valid domain)
  // -------------------------------------------------------------
  let rawWebsiteVal = websiteInput ? websiteInput.value.trim() : "";
  let isValidWebsite = false;
  let formattedWebsite = rawWebsiteVal;

  if (rawWebsiteVal) {
    // Agar user ne http:// ya https:// nahi lagaya, to prepend karein
    if (!/^https?:\/\//i.test(formattedWebsite)) {
      formattedWebsite = "https://" + formattedWebsite;
    }

    try {
      const parsedUrl = new URL(formattedWebsite);
      const hostname = parsedUrl.hostname;
      const domainPattern = /^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z]{2,})+$/;

      if (domainPattern.test(hostname)) {
        isValidWebsite = true;
      }
    } catch (e) {
      isValidWebsite = false;
    }
  }

  if (!isValidWebsite) {
    if (websiteInput) {
      websiteInput.setCustomValidity("Please enter a valid website URL (e.g. company.com or https://company.com).");
      websiteInput.reportValidity();
    }
    return;
  } else if (websiteInput) {
    websiteInput.setCustomValidity("");
    websiteInput.value = formattedWebsite; // normalized valid URL form me set ho gaya
  }

  if (!form.reportValidity()) return;

  // Set Submitting Lock & UI State
  isSubmitting = true;
  status.style.color = "";
  status.textContent = "Submitting your details...";
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.style.opacity = "0.7";
  }

  // Extract Form Data
  const firstName = form.querySelector("#guarantee-name")?.value.trim() || "";
  const website = formattedWebsite;
  const messageVal = messageInput ? messageInput.value.trim() : "";
  const cleanPhone = digitsOnly;

  const formId = form.getAttribute("id") || "holistic-growth-form";
  const formAction = form.getAttribute("action") || form.action || "";

  try {
    const brevoFormData = new FormData(form);
    brevoFormData.set("EMAIL", emailVal);
    brevoFormData.set("PHONE_NUMBER", cleanPhone);
    brevoFormData.set("WEBSITE_URL", website);
    brevoFormData.set("MESSAGE", messageVal);

    // -------------------------------------------------------------
    // 4. BREVO API SUBMISSION
    // -------------------------------------------------------------
    let brevoResponse;
    try {
      brevoResponse = await fetch(formAction, {
        method: "POST",
        body: brevoFormData,
        headers: {
          "Accept": "application/json"
        },
        mode: "cors"
      });
    } catch (networkErr) {
      throw new Error("Network error. Please check your internet connection.");
    }

    let brevoData = null;
    const responseText = await brevoResponse.text();
    try {
      brevoData = JSON.parse(responseText);
    } catch (e) {
      console.warn("Brevo sent non-JSON response:", responseText);
    }

    console.log("Brevo API Status:", brevoResponse.status, "Data:", brevoData);

    const hasBrevoErrors = brevoData && (
      (brevoData.errors && Object.keys(brevoData.errors).length > 0) ||
      brevoData.status === "error" ||
      brevoData.success === false
    );

    if (!brevoResponse.ok || hasBrevoErrors) {
      let errorMsg = "Unable to save your details in Brevo.";

      if (brevoData?.errors) {
        if (typeof brevoData.errors === "object") {
          errorMsg = Object.entries(brevoData.errors)
            .map(([field, msg]) => `• ${field}: ${msg}`)
            .join("<br>");
        } else {
          errorMsg = String(brevoData.errors);
        }
      } else if (brevoData?.message) {
        errorMsg = brevoData.message;
      }

      status.style.color = "#d93025";
      status.innerHTML = errorMsg;
      return;
    }

    // -------------------------------------------------------------
    // 5. D8A.CX TRACKING (Safe Isolated Call)
    // -------------------------------------------------------------
    const nowIso = new Date().toISOString();
    const randomAnonId = "c773f797-9613-4605-8818-" + Math.random().toString(36).substring(2, 14);
    const randomMsgId = "msg-" + Math.random().toString(36).substring(2, 15);

    const d8aPayload = {
      properties: {
        firstName: firstName,
        email: emailVal,
        phone: cleanPhone,
        websiteUrl: website,
        message: messageVal,
        formId: formId,
        formAction: formAction
      },
      event: "growth_form_submitted",
      type: "track",
      channel: "web",
      context: {
        traits: {
          email: emailVal,
          action_name: "Holistic Growth Form Submitted Identified"
        },
        sessionId: Date.now(),
        app: {
          name: "Holistic Growth Wellness",
          version: "1.0.0"
        },
        userAgent: navigator.userAgent,
        locale: navigator.language || "en-US",
        page: {
          path: window.location.pathname || "/holistic-growth-wellness",
          referrer: document.referrer,
          referring_domain: document.referrer ? new URL(document.referrer).hostname : "",
          title: document.title || "Holistic Growth Wellness",
          url: window.location.href
        }
      },
      originalTimestamp: nowIso,
      messageId: randomMsgId,
      userId: emailVal,
      anonymousId: randomAnonId,
      integrations: { All: true },
      sentAt: nowIso
    };

    try {
      await fetch("https://cdp.d8a.cx/v1/track", {
        method: "POST",
        headers: {
          "accept": "application/json",
          "authorization": "Basic ZnlvenhwZ2loaXVnemh2Z3Bmb3dpYmNkZWF4bnB2cmE6",
          "content-type": "application/json;charset=UTF-8",
          "sentat": nowIso,
          "anonymousid": randomAnonId
        },
        body: JSON.stringify(d8aPayload),
        mode: "cors"
      });
      console.log("D8a tracking event successfully recorded.");
    } catch (d8aErr) {
      console.warn("D8a tracking failed (likely ad-blocker):", d8aErr);
    }

    // -------------------------------------------------------------
    // 6. SUCCESS UI
    // -------------------------------------------------------------
    status.style.color = "#16a34a";
    status.textContent = "Thank you! Your details have been received. We'll be in touch shortly.";

    form.reset();

    setTimeout(() => {
      if (typeof guaranteeDialog !== "undefined" && guaranteeDialog.close) {
        guaranteeDialog.close();
      }
      status.textContent = "";
    }, 3500);

  } catch (error) {
    console.error("Form submission error:", error);
    status.style.color = "#d93025";
    status.textContent = error.message || "Something went wrong while sending your details. Please try again.";
  } finally {
    isSubmitting = false;
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.style.opacity = "";
    }
  }
});
}


